// Vendors
import { CountriesLocaleEnum } from '@openbank/ziniaweb-ui-core-models';

const ALLOWED_LANGUAGES = [CountriesLocaleEnum.SPAIN, CountriesLocaleEnum.ENGLAND];

const LOCALE_QUERY_PARAM = 'language';

export { ALLOWED_LANGUAGES, LOCALE_QUERY_PARAM };
